import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';

import * as userActions from '../user.actions';
import * as authActions from '../../auth/auth.actions';
import ResetPasswordForm from './ResetPasswordForm';

import { ContentBlock } from '../../pages/components';
import BaseFormContainer from '../../common/components/form/BaseFormContainer';
import Button from '../../../ui/button/Button';
import { Localize } from '../../../locale/localization';

const constraints = {
  password: {
    presence: {
      message: `^${Localize('form.reset-password.password.error')}`
    }
  },
  passwordConfirm: {
    presence: {
      message: `^${Localize('form.reset-password.password-confirm.error')}`
    },
    equality: {
      attribute: "password",
      message: `^${Localize('form.reset-password.password-equality.error')}`
    }
  },
};

class ResetPasswordFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      password: '',
      passwordConfirm: '',
    };

    this.state = {
      ...this.state,
      formData,
    };
  }

  componentWillMount = () => {
    const {
      emailToken,
      validateEmailToken,
    } = this.props;

    validateEmailToken(emailToken)
      .then((response) => {
        this.setState({
          validatedToken: true,
          isValidToken: true,
          authToken: response.response.authToken,
        });
      })
      .catch((error) => {
        this.setState({
          validatedToken: true,
          isValidToken: false,
          authToken: null,
        });
      });
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { resetPassword, emailToken, loginUserToken, history } = this.props;
    const {
      authToken,
    } = this.state;

    resetPassword({
      emailToken,
      ...formData,
    }).then(() => {
      loginUserToken(authToken).then(() => {
      history.replace('/');
      });
    }).catch((e) => {
      history.replace('/');
    });

    //TODO Success & error handling
  }

  render() {
    const { isValidToken } = this.state;
    return (
      isValidToken ? (
        <ResetPasswordForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          password={this.state.formData.password}
          passwordConfirm={this.state.formData.passwordConfirm}
        />
      ) : (
        <ContentBlock title="Virhe" center>
          <p>Virheellinen linkki.</p>
          <footer>
            <NavLink to="/" replace>
              <Button>Etusivulle</Button>
            </NavLink>
          </footer>
        </ContentBlock>
      )
    );
  }
}


const mapStateToProps = (state, { match }) => {
  const {
    emailToken
  } = match.params;

  return {
    emailToken,
  };
};

const ConnectedResetPasswordFormContainer = connect(
  mapStateToProps,
  Object.assign({}, userActions, authActions),
)(ResetPasswordFormContainer);

export default withRouter(ConnectedResetPasswordFormContainer);


// WEBPACK FOOTER //
// ./src/modules/user/components/ResetPasswordFormContainer.js